/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ player: NonNullable<unknown> }} Admin_Delete_Player_ConfirmInputs */

const th_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ลบ ${i?.player} หรือไม่? ทีมที่สังกัด รายการแข่งขัน การเข้าร่วม และผู้ปกครองจะถูกลบไปด้วย การกระทำนี้ย้อนกลับไม่ได้`)
};

const en_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.player}? Their squads, event entries, attendance and guardians go with them. This cannot be undone.`)
};

const ja_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} を削除しますか？所属チーム、大会エントリー、出欠、保護者の情報も一緒に削除されます。元に戻せません。`)
};

const zh_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除 ${i?.player}？阵容、报名、出勤和监护人信息会一并消失。此操作无法撤销。`)
};

const es_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar a ${i?.player}? Sus plantillas, inscripciones, asistencia y tutores se eliminan con él. Esto no se puede deshacer.`)
};

const pt_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Excluir ${i?.player}? Os elencos, inscrições, presenças e responsáveis vão junto. Isso não pode ser desfeito.`)
};

const id_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hapus ${i?.player}? Skuad, pendaftaran, kehadiran dan walinya ikut terhapus. Ini tidak bisa dibatalkan.`)
};

const fr_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.player} ? Ses effectifs, inscriptions, présences et tuteurs partent avec. C’est irréversible.`)
};

const tl_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Burahin si ${i?.player}? Kasama ang mga squad, rehistrasyon, attendance at tagapag-alaga. Hindi ito maibabalik.`)
};

const vi_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá ${i?.player}? Đội hình, đăng ký, điểm danh và người giám hộ cũng mất theo. Không thể hoàn tác.`)
};

const ko_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player}을(를) 삭제할까요? 선수단, 등록, 출석, 보호자 정보도 함께 사라집니다. 되돌릴 수 없습니다.`)
};

const de_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} löschen? Kader, Anmeldungen, Anwesenheiten und Erziehungsberechtigte gehen mit. Das lässt sich nicht rückgängig machen.`)
};

const ru_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удалить ${i?.player}? Составы, заявки, посещаемость и опекуны исчезнут вместе с ним. Это необратимо.`)
};

const tr_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} silinsin mi? Kadrolar, kayıtlar, yoklamalar ve veliler de gider. Bu geri alınamaz.`)
};

const it_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminare ${i?.player}? Spariscono anche rose, iscrizioni, presenze e tutori. L'operazione è irreversibile.`)
};

const pl_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usunąć ${i?.player}? Znikną też składy, zgłoszenia, obecności i opiekunowie. Tego nie da się cofnąć.`)
};

const uk_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Видалити ${i?.player}? Склади, заявки, відвідуваність і опікуни зникнуть разом із ним. Це незворотно.`)
};

const hi_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} को हटाएँ? टीमें, पंजीकरण, उपस्थिति और अभिभावक भी चले जाएँगे। इसे पलटा नहीं जा सकता।`)
};

const ar_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`حذف ${i?.player}؟ ستُحذف معه التشكيلات والتسجيلات والحضور وأولياء الأمور. لا يمكن التراجع عن ذلك.`)
};

const ms_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Padam ${i?.player}? Skuad, pendaftaran, kehadiran dan penjaga turut hilang. Tindakan ini tidak boleh dibatalkan.`)
};

const bn_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player}-কে মুছবেন? দল, নিবন্ধন, উপস্থিতি ও অভিভাবকের তথ্যও চলে যাবে। এটি ফেরানো যাবে না।`)
};

const zh_tw2_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`刪除 ${i?.player}？名單、報名、出席與監護人資料都會一併消失。此操作無法復原。`)
};

const zh_hk2_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`刪除 ${i?.player}？名單、報名、出席與監護人資料都會一併消失。此操作無法復原。`)
};

const ur_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} کو حذف کریں؟ اسکواڈ، رجسٹریشن، حاضری اور سرپرست بھی ختم ہو جائیں گے۔ اسے واپس نہیں کیا جا سکتا۔`)
};

const fa_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} حذف شود؟ فهرست تیم، ثبت‌نام‌ها، حضور و غیاب و سرپرستان هم از بین می‌روند. این کار برگشت‌پذیر نیست.`)
};

const sw_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Futa ${i?.player}? Vikosi, usajili, mahudhurio na walezi vitaondoka pia. Hili haliwezi kutenduliwa.`)
};

const nl_admin_delete_player_confirm = /** @type {(inputs: Admin_Delete_Player_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} verwijderen? Selecties, inschrijvingen, aanwezigheid en voogden gaan mee. Dit kan niet ongedaan worden gemaakt.`)
};

/**
* | output |
* | --- |
* | "Delete {player}? Their squads, event entries, attendance and guardians go with them. This cannot be undone." |
*
* @param {Admin_Delete_Player_ConfirmInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_delete_player_confirm = /** @type {((inputs: Admin_Delete_Player_ConfirmInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Delete_Player_ConfirmInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_delete_player_confirm(inputs)
	if (locale === "ja") return ja_admin_delete_player_confirm(inputs)
	if (locale === "zh") return zh_admin_delete_player_confirm(inputs)
	if (locale === "es") return es_admin_delete_player_confirm(inputs)
	if (locale === "pt") return pt_admin_delete_player_confirm(inputs)
	if (locale === "id") return id_admin_delete_player_confirm(inputs)
	if (locale === "fr") return fr_admin_delete_player_confirm(inputs)
	if (locale === "tl") return tl_admin_delete_player_confirm(inputs)
	if (locale === "vi") return vi_admin_delete_player_confirm(inputs)
	if (locale === "ko") return ko_admin_delete_player_confirm(inputs)
	if (locale === "de") return de_admin_delete_player_confirm(inputs)
	if (locale === "ru") return ru_admin_delete_player_confirm(inputs)
	if (locale === "tr") return tr_admin_delete_player_confirm(inputs)
	if (locale === "it") return it_admin_delete_player_confirm(inputs)
	if (locale === "pl") return pl_admin_delete_player_confirm(inputs)
	if (locale === "uk") return uk_admin_delete_player_confirm(inputs)
	if (locale === "hi") return hi_admin_delete_player_confirm(inputs)
	if (locale === "ar") return ar_admin_delete_player_confirm(inputs)
	if (locale === "ms") return ms_admin_delete_player_confirm(inputs)
	if (locale === "bn") return bn_admin_delete_player_confirm(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_delete_player_confirm(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_delete_player_confirm(inputs)
	if (locale === "ur") return ur_admin_delete_player_confirm(inputs)
	if (locale === "fa") return fa_admin_delete_player_confirm(inputs)
	if (locale === "sw") return sw_admin_delete_player_confirm(inputs)
	if (locale === "nl") return nl_admin_delete_player_confirm(inputs)
	return en_admin_delete_player_confirm(inputs)
});